<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-col md="12" class="pa-3 d-flex flex-column" v-if="this.condition()" >
        <a class="anchor" id="blocca"></a>

    <v-card elevation="2" v-if="!this.bilanGratuitValeurVide()">
      <v-card-title><v-icon dense left color="teal">mdi-currency-eur</v-icon> {{ dernierBilan }}</v-card-title>

    </v-card>

    <v-card elevation="2" v-else>
      <v-card-title><v-icon dense left color="teal">mdi-currency-eur</v-icon> Bilan ({{ dernierBilan }})</v-card-title>
      <v-card-text>
        <v-btn depressed @click="copy(bilanGratuit)">Copier les données</v-btn>
      </v-card-text>
      <v-card-text>
        <v-data-table
            dense
            :headers="headers"
            :items="bilanGratuit"
            item-key="annee"
            class="elevation-1"
        >
          <template
              v-for="header in headers.filter((header) =>
            header.hasOwnProperty('formatter')
          )"
              v-slot:[`item.${header.value}`]="{ header, value }"
          >
            {{ header.formatter(value) }}
          </template>
        </v-data-table>
        <b>Indicateurs</b>
        <ul>
          <li>Ratio dettes / fonds propres : Dettes financières - trésorerie / fonds propres</li>
          <li>Ratio fonds propres / bilan : fonds propres / Total bilan</li>
          <li>Ratio resultat / CA : Bénéfices ou pertes / Chiffre d'affaires</li>
          <li>Ratio resultat exploitation / CA : Chiffre d'affaire - charges d'exploitation / Chiffre d'affaires</li>
        </ul>
      </v-card-text>

      <v-card-title><v-icon dense left color="teal">mdi-chart-areaspline</v-icon>  Evolution Bilan ({{ dernierBilan }})</v-card-title>
      <v-card-text>
        <D3LineChart :config="chart_config" :datum="bilanGratuit"></D3LineChart>

        Bleu : CA, Gris : charges d'exploitation, Vert : Total bilan, Rouge : dettes
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>

import {D3LineChart} from 'vue-d3-charts';


export default {
  name: "BilanGratuit",
  props: [],
  components: {
    D3LineChart
  },
  data() {
    return {
      chart_config: {
        values: ['chiffredaffaires', 'chargesdexploitation', "dettesfinancieres", "totalbilan"],
        color: {
          scheme: ['#3455eb', '#bfbfbf', '#ff0000', "#04ff00"]
        },
        date: {
          key: 'year',
          inputFormat: '%Y',
          outputFormat: '%Y',
        },
        axis: {
          yFormat: '.1s',
          yTicks: 6,
          xTicks: 5,
          yTitle: "Score"
        },
        points: {
          visibleSize: 4,
          hoverSize: 6,
        },
        tooltip: {
          labels: ["Chiffre d'affaires", "Charges d'expliotation", "Dettes", "Total bilan"]
        },
        curve: "curveLinear",
        transition: {
          ease: 'easeBounceOut',
          duration: 1000
        }
      }
    }
  },
  computed: {
    bilanGratuit: function () {
      var bilan = this.$store.getters.getbloc("finance", "donnees", "bilanGratuit", null, "valeur")
      bilan = bilan.map(x => this.format_date_for_graph(x) );
      return bilan;
    },
    dernierBilan: function () {
      return this.$store.getters.getbloc("finance", "donnees", "bilanGratuit", "Pas de bilan", "libelle")
    },
    headers() {
      return [
        {
          text: "Année",
          align: "start",
          sortable: false,
          value: "annee",
          fixed: true,
          width: "10px",
        },
        {
          text: "Chiffre d'affaires",
          value: "chiffredaffaires",
          align: "end",
          fixed: true,
          width: "100px",
          formatter: this.formatCurrency,
        },
        {
          text: "Charges d'exploitation",
          value: "chargesdexploitation",
          align: "end",
          fixed: true,
          width: "100px",
          formatter: this.formatCurrency,
        },
        {
          text: "Bénéfice ou perte",
          value: "beneficeouperte",
          align: "end",
          fixed: true,
          width: "100px",
          formatter: this.formatCurrency,
        },
        {
          text: "Fonds Propres",
          value: "fondspropres",
          align: "end",
          fixed: true,
          width: "100px",
          formatter: this.formatCurrency,
        },
        {
          text: "Immobilisations nettes",
          value: "immobilisationsnettes",
          align: "end",
          fixed: true,
          width: "100px",
          formatter: this.formatCurrency,
        },
        {
          text: "Trésorerie",
          value: "tresorerie",
          align: "end",
          fixed: true,
          width: "100px",
          formatter: this.formatCurrency,
        },
        {
          text: "Dettes financieres",
          value: "dettesfinancieres",
          align: "end",
          fixed: true,
          width: "100px",
          formatter: this.formatCurrency,
        },
        {
          text: "Total Bilan",
          value: "totalbilan",
          align: "end",
          fixed: true,
          width: "100px",
          formatter: this.formatCurrency,
        },
        {
          text: "Frais financiers",
          value: "fraisfinanciers",
          align: "end",
          fixed: true,
          width: "100px",
          formatter: this.formatCurrency,
        },
        {
          text: "Produits financiers",
          value: "produitsfinanciers",
          align: "end",
          fixed: true,
          width: "100px",
          formatter: this.formatCurrency,
        },
        {
          text: "Salaires et charges",
          value: "salairesetcharges",
          align: "end",
          fixed: true,
          width: "100px",
          formatter: this.formatCurrency,
        },
        {
          text: "Nombre d'employes",
          value: "nombredemployes",
          align: "end",
          fixed: true,
          width: "100px",
        },
         {
          text: "Ratio dettes / fonds propres",
          value: "ratiodettefondspropres",
          align: "end",
          fixed: true,
          width: "100px",
           formatter: this.formatPct,
        },
        {
          text: "Ratio fonds propres / bilan",
          value: "ratiofondsproprestotalbilan",
          align: "end",
          fixed: true,
          width: "100px",
           formatter: this.formatPct,
        },
          {
          text: "Ratio resultat / CA",
          value: "ratioresultatca",
          align: "end",
          fixed: true,
          width: "100px",
           formatter: this.formatPct,
        },
          {
          text: "Ratio resultat exploitation / CA",
          value: "ratioresultatexploitca",
          align: "end",
          fixed: true,
          width: "100px",
           formatter: this.formatPct,
        },
      ];
    },
  },
  methods: {
     async copy(s) {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(this.ConvertToCSV(JSON.stringify(s)));
            alert('Copied!');
          }
    },
    format_date_for_graph(x) {
       // ajoute un champs year car année peut contenir 2014(6 mois) par exemple
      // ce qui pose probleme pour le graphe
       x.year = x.annee.substring(0,4)
       return x;

    },
      ConvertToCSV(objArray) {
          var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
          var str = "";

          let keys = Object.keys(array[0]);
          str += keys.join("\t")+  '\r\n';

          for (var i = 0; i < array.length; i++) {
              var line = '';
              for (var index in array[i]) {
                  if (line != '') line += '\t'

                  line += array[i][index];
              }

              str += line + '\r\n';
          }

          return str;
      },
    condition() {
      return (this.$store.getters.condition(
          "finance",
          "donnees",
          "bilanGratuit",
          "valeur"
      ) || this.$store.getters.condition(
          "finance",
          "donnees",
          "bilanGratuit",
          "libelle")
      )
    },
    bilanGratuitValeurVide() {
      return this.$store.getters.condition(
          "finance",
          "donnees",
          "bilanGratuit",
          "valeur")
    },
    formatCurrency(value) {
      if (value) {
        return value.toLocaleString() + "€";
      } else {
        return "";
      }
    },
    formatPct(value) {
      if (value) {
        return (value*100).toFixed(2)+"%";
      } else {
        return "";
      }
    },
  },
};
</script>
